import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // импортируем Link
import Hero from '../components/Hero';
import NewsGrid from '../components/NewsGrid';
import About from '../components/About';
import Contacts from '../components/Contacts';
import CallToAction from '../components/CallToAction';
import { getNews } from '../api';
import { contactsData } from '../data/contactsData';
import CandidatesSection from '../components/CandidatesSection';
import GallerySection from '../components/GallerySection';
import SEO from '../components/SEO';

const HomePage = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNews(6, 0)
      .then(response => {
        setNews(response.data);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Загрузка новостей...</div>;

  return (
    <>
      <SEO title="Главная" description="Нефтеюганское отделение КПРФ: новости, кандидаты, партийная программа." />
      <Hero />
      <main className="container">
        <h2 className="section-title" id="news">Последние новости</h2>
        <NewsGrid news={news} />
        {/* Новая кнопка под новостями */}
        <div className="archive-button-wrapper">
          <Link to="/archived-news" className="btn-archive">📂 Архив новостей</Link>
        </div>
        <About />
        <h2 className="section-title">Наши Товарищи</h2>
        <div id="candidates">
            <CandidatesSection />
        </div>
        
        <div id="Gallery">
            <GallerySection />
        </div>
        <h2 className="section-title" id="contacts">Контакты</h2>
        <Contacts contacts={contactsData} />
        <CallToAction />
      </main>
    </>
  );
};

export default HomePage;